<h1>Step on Fried Egg</h1>

<p>1.Start with a Fresh Egg.</p>
<img src="images/OneEgg.jpg" alt="EGGGGGGGGG">


<p>2.Use a CAST IRON Pan if you have one, if not, use any Pan if its not too small!</p>

<p>3.Crack the Egg into a bowl First.</p>
<img src="images/FriedEggCracked.jpg" alt="">

<p>4.Make sure the Oil is 𝓗𝓞𝓣 before you Pour in the Egg.</p>
<img src="images/OmeletStep6.gif" alt="">
<img src="images/FriedEggStep5.gif" alt="">
<p>5.Be Careful and watch out for 𝓗𝓞𝓣 Oil Splatters</p>

<p>6.Flip the Fried Egg: If you want both sides to be Cooked or not, if you want the other side to be slightly Cooked.</p>
<img src="images/FriedEggFlip.gif" alt="EGGGGGGGGG">
<p>7.Done! Now get that Egg onto your plate and BLAST IT INTO YOUR MOUTH!</p>
<img src="images/EggDone.jpg" alt="EGGGGGGGGG">
<p><i>YUMMY!</i></p>
<br>
